module.exports = __webpack_public_path__ + "static/media/NFFC.8c184727.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/mobile/NFFC.svg
// module id = 104
// module chunks = 0